import * as React from 'react';

import Musthead from '@app/components/UI/MustHead/Musthead';
import RichText from '@app/components/UI/RichText/RichText';
import {headerText, listContent, warningText} from '@app/components/Pages/Covid19/Covid19Content';
import VideoEmbed from '@app/components/UI/VideoEmbed/VideoEmbed';
import withSeo from '@app/components/LocalCommon/HigherOrderComponents/WithSeo';

const Covid19 = () => {
	return(
		<div>
			<Musthead
				title="Covid-19 Update"
				imageSrc={require('@app/content/covid-protocol.jpg')}
				imageAlt="Dr. Dani helps sick dog"
			/>
			<RichText
				title=""
				text={headerText}
			/>

			<VideoEmbed text={warningText} />

			<RichText
				title="We will also be taking the following precautions to ensure both you and our team remains safe:"
				text={listContent}
			/>
		</div>
	);
};

export default withSeo(Covid19, state => state.covidPage, 'covidPage', 'covid19');